const proportion = (pixelValue: number, key = 'desktop') => ({ theme }) =>
  `${(pixelValue / theme.proportions[key]) * 100}vw`

export default proportion
